'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Modal = require('../Modal/Modal.js');
require('./_index.scss.js');

var _excluded = ["className", "iconId", "type", "title", "placeholder", "unit", "large", "readOnly", "value", "controlledValue", "required", "requiredLabel", "optionalLabel", "name", "innerRef", "errorTitle", "light", "disabled", "validator", "info"];
var CLASSNAME = 'varta-input',
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnLight = "".concat(CLASSNAME, "--light"),
    cnFocus = "".concat(CLASSNAME, "--focus"),
    cnLarge = "".concat(CLASSNAME, "--large"),
    cnReadOnly = "".concat(CLASSNAME, "--read-only"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnTitleError = "".concat(cnTitle, "--error"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnInput = "".concat(CLASSNAME, "__input"),
    cnInputWithUnit = "".concat(cnInput, "--with-unit"),
    cnUnit = "".concat(CLASSNAME, "__unit"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnIconInfo = "".concat(CLASSNAME, "__icon-info");
/**
 * 
 */

var Input = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Input, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Input);

  function Input() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      error: _this.props.error,
      focus: false
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBlur", function (e) {
      var value = e.target.value,
          _this$props = _this.props,
          onBlur = _this$props.onBlur,
          validator = _this$props.validator,
          errorTitle = _this$props.errorTitle;
      var error = _this.state.error;
      var valid;

      if (error) {
        valid = _this.validate(e);
      }

      _this.setState({
        focus: false
      }); // If validator is a function, form submissions will always succeed because it only checks HTML-validty
      // By setting setCustomValidity, form submissions will trigger the onInvalid event


      if (typeof validator === 'function' && errorTitle) {
        valid = _this.validate(e, true);

        if (valid) {
          _this.ref.setCustomValidity('');
        } else {
          _this.ref.setCustomValidity(errorTitle);
        }
      } else if (typeof validator === 'function' && !errorTitle) {
        throw Error('errorTitle is required if validator is a function');
      }

      onBlur(value, valid);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focus: true
      });

      onFocus();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onKeyPress", function (e) {
      // trigger validation before submitting
      if (e.charCode === 13) {
        _this.onBlur(e);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "validate", function (e, silent) {
      var value = e.target.value,
          required = _this.props.required;
      var validator = _this.props.validator;
      var validatorRegExp = _this.state.validatorRegExp;

      if (required && !value) {
        if (!silent) {
          _this.setState({
            error: true
          });
        }

        return false;
      }

      if (validatorRegExp && value) {
        var error = !value.match(validatorRegExp);

        if (!silent) {
          _this.setState({
            error: error
          });
        }

        return !error;
      } else if (typeof validator === 'function') {
        var _error = !validator(value);

        if (!silent) {
          _this.setState({
            error: _error
          });
        }

        return !_error;
      }

      _this.setState({
        error: false
      }); // if (validator) {
      //     this.ref.setCustomValidity('')
      // }


      return true;
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Input, [{
    key: "onChange",
    value: function onChange(e) {
      var value = e.target.value,
          _this$props2 = this.props,
          onChange = _this$props2.onChange,
          errorTitle = _this$props2.errorTitle;
      var error = this.state.error;

      if (error) {
        // hide browser validation message while typing
        if (this.validate(e)) {
          this.ref.setCustomValidity('');
        } else {
          this.ref.setCustomValidity(errorTitle);
        }
      }

      onChange(value);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props3 = this.props,
          unit = _this$props3.unit,
          readOnly = _this$props3.readOnly,
          onClick = _this$props3.onClick;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, unit && /*#__PURE__*/React__default.createElement("span", {
        className: cnUnit
      }, unit), readOnly && /*#__PURE__*/React__default.createElement("button", {
        className: cnButton,
        onClick: onClick
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "edit",
        size: "xs"
      })));
    }
  }, {
    key: "renderInputElement",
    value: function renderInputElement(props) {
      var _this2 = this;

      var className = props.className,
          iconId = props.iconId,
          type = props.type,
          title = props.title,
          placeholder = props.placeholder,
          unit = props.unit,
          large = props.large,
          readOnly = props.readOnly,
          value = props.value,
          controlledValue = props.controlledValue,
          required = props.required,
          requiredLabel = props.requiredLabel,
          optionalLabel = props.optionalLabel,
          name = props.name,
          innerRef = props.innerRef,
          errorTitle = props.errorTitle,
          light = props.light,
          disabled = props.disabled,
          validator = props.validator,
          info = props.info,
          rest = _rollupPluginBabelHelpers.objectWithoutProperties(props, _excluded),
          validatorString = this.state.validatorString;

      return /*#__PURE__*/React__default.createElement("input", _rollupPluginBabelHelpers.extends({}, rest, {
        className: classNames(cnInput, _rollupPluginBabelHelpers.defineProperty({}, cnInputWithUnit, unit)),
        type: type,
        placeholder: placeholder,
        readOnly: readOnly,
        disabled: disabled,
        defaultValue: value,
        value: controlledValue,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyPress: this.onKeyPress,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        required: required,
        name: name,
        ref: function ref(el) {
          if (typeof innerRef === 'function') {
            innerRef(el);
          } else if (innerRef) {
            innerRef.current = el;
          }

          _this2.ref = el;
        },
        tabIndex: readOnly ? -1 : 0,
        onInvalid: this.validate,
        pattern: validatorString
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2,
          _this3 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var className = props.className,
          iconId = props.iconId,
          type = props.type,
          title = props.title,
          large = props.large,
          readOnly = props.readOnly,
          required = props.required,
          requiredLabel = props.requiredLabel,
          optionalLabel = props.optionalLabel,
          errorTitle = props.errorTitle,
          light = props.light,
          disabled = props.disabled,
          hidden = props.hidden,
          info = props.info,
          _this$state = this.state,
          error = _this$state.error,
          focus = _this$state.focus,
          showInfo = _this$state.showInfo,
          classes = classNames(CLASSNAME, className, this.className, (_classNames2 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames2, cnLarge, large), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnReadOnly, readOnly), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnFocus, focus), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnLight, light), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnDisabled, disabled), _classNames2));

      if (hidden) {
        return this.renderInputElement(props);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classes,
        hidden: type === 'hidden'
      }, /*#__PURE__*/React__default.createElement("label", null, /*#__PURE__*/React__default.createElement("div", {
        className: cnTitle
      }, title, required ? requiredLabel : optionalLabel, info && /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          _this3.setState({
            showInfo: true
          });
        },
        className: cnIconInfo
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "questionmark-alt",
        size: "xxs"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, iconId && /*#__PURE__*/React__default.createElement(Icon, {
        className: cnIcon,
        id: iconId,
        size: large ? 'md' : 'xs'
      }), this.renderInputElement(props), this.renderContent()), /*#__PURE__*/React__default.createElement("div", {
        className: cnTitleError
      }, errorTitle)), info && /*#__PURE__*/React__default.createElement(Modal, {
        onClose: function onClose() {
          return _this3.setState({
            showInfo: false
          });
        },
        title: info.title,
        image: info.image,
        open: showInfo,
        showCloseButton: true
      }, /*#__PURE__*/React__default.createElement(RichText, {
        content: info.content
      })));
    }
  }], [{
    key: "escapeRegex",
    value:
    /**
     * @see https://stackoverflow.com/a/3561711/1301058
     * @param {String} string
     */
    function escapeRegex(string) {
      return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var error = state.error; // reset error state if input is disabled

      if (props.disabled) {
        error = false;
      } // store validator as RegExp and String


      if (props.validator !== state.validatorString && typeof props.validator === 'string') {
        return {
          validatorString: Input.escapeRegex(props.validator),
          validatorRegExp: new RegExp("^".concat(Input.escapeRegex(props.validator), "$")),
          error: error
        };
      } else if (props.validator && typeof props.validator === 'function') {
        return {
          error: error
        };
      } else if (props.validator && props.validator !== state.validatorRegExp) {
        var _props$validator$toSt, _props$validator;

        return {
          validatorString: (_props$validator$toSt = (_props$validator = props.validator).toString) === null || _props$validator$toSt === void 0 ? void 0 : _props$validator$toSt.call(_props$validator).replace(/^\/|\/$/g, ''),
          validatorRegExp: props.validator,
          error: error
        };
      }

      return {
        error: error
      };
    }
  }]);

  return Input;
}(React__default.Component);
Input.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  controlledValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** */
  disabled: PropTypes.bool,

  /** */
  errorTitle: PropTypes.string,

  /** */
  error: PropTypes.bool,

  /** */
  iconId: PropTypes.string,

  /** */
  info: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    content: PropTypes.string
  }),

  /** */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /** */
  large: PropTypes.bool,

  /** */
  light: PropTypes.bool,

  /** */
  name: PropTypes.string,

  /** */
  onBlur: PropTypes.func,

  /** */
  onChange: PropTypes.func,

  /** */
  onClick: PropTypes.func,

  /** */
  onFocus: PropTypes.func,

  /** */
  optionalLabel: PropTypes.string,

  /** */
  placeholder: PropTypes.string,

  /** */
  readOnly: PropTypes.bool,

  /** */
  requiredLabel: PropTypes.string,

  /** */
  required: PropTypes.bool,

  /** */
  title: PropTypes.string,

  /** */
  type: PropTypes.string,

  /** */
  unit: PropTypes.string,

  /** */
  validator: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.instanceOf(RegExp)]),

  /** */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
Input.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  type: 'text',
  onClick: function onClick() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  }
});

module.exports = Input;
